import { useEffect, useState } from "react"
import { Col, Form, Row, Select, Skeleton, TreeSelect, useCRUDController } from "../../ui/ot"
import { TreeSelectLazy } from "../department_role_management"

const useRoleDepartmentFormController = ({

}) => {
    const [form] = Form.useForm()

    const getFormValues = (departmentOptionController) => {
        const formValues = form.getFieldsValue();
        let role_id_arr = formValues?.role_id_arr?.map(role => role?.value) ?? []
        let department_id_arr = formValues?.department_id_arr?.reduce((all, department) => ([...all, ...(department ?? [])]), []) ?? []
        department_id_arr = department_id_arr.map(department => {
            return departmentOptionController.ResponseData?.find(findItem => findItem.classify_structure_type_id == department)?.department_id ?? 0
        })
        return {
            role_id_arr,
            department_id_arr
        }
    }


    return {
        form,
        getFormValues
    }
}

const RoleDepartmentForm = ({
    propsForm,
    propsRole = true,
    propsStaffDepartmentDropdown = undefined,
    propsDepartmentController
}) => {
    const form = propsForm

    const [loadingCount, setLoadingCount] = useState(0);

    const onFinish = () => {
        setLoadingCount(pre => pre + 1)
    }

    const roleOptionController = useCRUDController({ onFinish, apiRoute: "/organization_structure/api/role_dropdown" });

    const departmentController_ = useCRUDController({ onFinish, apiRoute: "/organization_structure/api/department_dropdown" });
    const departmentController = propsDepartmentController ?? departmentController_

    useEffect(() => {
        if (propsStaffDepartmentDropdown !== undefined || departmentController?.ResponseData?.length === 0) {
            departmentController.getData({ classify_structure_type_id: 0, classify_structure_id: 9, staff_department_dropdown: propsStaffDepartmentDropdown })
        } else {
            setLoadingCount(pre => pre + 1)
        }
        roleOptionController.getData({ departmentMode: propsStaffDepartmentDropdown, all: true })
    }, [])
    return <>
        {loadingCount !== 2 && <>
            <div style={{ maxWidth: '100%' }}>
                <Skeleton />
            </div>
        </>}
        {loadingCount === 2 && <Form
            form={form}
        >
            <Row gutter={[24, 24]}>
                {!propsRole && <Col span={8}>
                    <Form.Item
                        label={'角色'}
                        name={"role_id_arr"}
                    >
                        <Select
                            mode={"multiple"}
                            onlyValue={false}
                            options={roleOptionController.ResponseData?.map(role => (
                                {
                                    label: role?.role_language_data?.find(_ => true)?.language_culture_value,
                                    value: role?.role_id
                                }
                            ))}
                        />
                    </Form.Item>
                </Col>}
                {departmentController.ResponseData?.map((department, departmentIndex) => <>
                    <Col span={8}>
                        <Form.Item
                            label={department?.department_language_data?.find(_ => true)?.language_culture_value}
                            name={"department_id_arr." + departmentIndex}
                        >
                            <TreeSelect
                                multiple
                                allowClear
                                treeDefaultExpandAll
                                treeData={departmentController?.ResponseData?.find(departmentChildren => department.department_id === departmentChildren?.department_id)?.children ?? []}
                                minWidth='200%'
                            />
                            {/* <TreeSelectLazy
                                multiple
                                allowClear
                                treeDefaultExpandAll
                                apiRoot={'/organization_structure/api/department_dropdown'}
                                propsTreeData={[
                                    {
                                        ...department,
                                        children: []
                                    }
                                ]}
                            /> */}
                        </Form.Item>
                    </Col>
                </>)}
            </Row>
        </Form>}
    </>
}
export { useRoleDepartmentFormController, RoleDepartmentForm }